import React, { Fragment } from 'react';
import type { Command, CommandActionCommandList, NameProps } from '../../types/commands/index.tsx';
import { CommandPaletteBody } from './body/index.tsx';
import { CommandRow } from './command-row/index.tsx';
import { Footer } from './footer/index.tsx';
import { Header } from './header/index.tsx';

type Components = NonNullable<
	Required<CommandActionCommandList['components'] & Command['components']>
>;

const NameComponent = ({ children }: NameProps) => {
	return <>{children}</>;
};

export const components: Components = {
	CommandRow,
	Name: NameComponent,
	LeftIcon: Fragment,
	Wrapper: Fragment,
	Footer,
	Body: CommandPaletteBody,
	Header,
};
